import createIcon from '../../icons/createIcon';

const IconChevronLeft = createIcon('IconChevronLeft', '0 0 64 64', [
    [
        'path',
        {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M41.3284 18.5003L39.9142 19.9145L28.3284 31.5003L39.9142 43.0861L41.3284 44.5003L38.5 47.3287L37.0858 45.9145L24.0858 32.9145C23.3047 32.1335 23.3047 30.8671 24.0858 30.0861L37.0858 17.0861L38.5 15.6719L41.3284 18.5003Z',
            fill: '#191B21',
            key: '9e2a56'
        },
        []
    ]
]);

export { IconChevronLeft };
